<template>
  <v-navigation-drawer
    fixed
    permanent
    :mini-variant="true"
    :mini-variant-width="80"
    class="primary sidebar"
  >
    <v-list v-if="authorized" two-line class="sidebar-list">
      <v-list-item
        :class="[$route.path.includes(item.link) ? 'selected' : '', 'list-item']"
        v-for="item in filteredMenuItems"
        :key="item.title"
        :to="item.link"
      >
        <v-list-item-action>
          <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          large
          class="white--text link-icon"
          v-bind="attrs"
          v-on="on"
        >{{item.icon}}</v-icon>
      </template>
      <span>{{item.title}}</span>
    </v-tooltip>
          
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "navdrawer",
  data() {
    return {
      menuItems: [
        // { icon: "person", title: "People", link: "/people", admin: false, authorized: true, selected: false },
        { icon: 'group', title: 'Groups', link: "groups", admin: false, authorized: true, selected: false },
        { icon: "business_center", title: "Skills", link: "/skills", admin: false, selected: false },
        { icon: "assignment", title: "Roles", link: "roles", admin: true, authorized: true, selected: false }
        // { icon: "build", title: "Settings", link: "settings", admin: false, authorized: true, selected: false },
      ],
    };
  },
  computed: {
    authorized() {
      return this.$store.getters.authorized;
    },
    administrator() {
      return this.$store.getters.administrator;
    },
    filteredMenuItems() {
      // Filter menu items depending on admin status
      if (this.administrator) {
        return this.menuItems;

      } else if (this.authorized) {
        return this.menuItems.filter(function(menuItems) {
          return menuItems.admin === false;
        }).map(item => {
          if(window.location.pathname.includes(item.link)){
            return Object.assign({}, item, {selected: true});
          }
          return item;
        });
      } 
    }
  },
};
</script>
<style scoped>
  .sidebar{
    position: fixed;
    top: 64px !important;
    z-index: 11;
    height: calc(100% - 64px) !important;
  }
  .sidebar-list{
    padding-top: 0px;
  }
  .list-item{
    height: 80px !important;
  }
  .selected{
    background-color: rgb(255, 255, 255, 0.3);
    border-width: 0px 0px 0px 3px;
    border-color: white;
    border-style: solid;
    padding-left: -3px;
  }
  .link-icon{
    padding: 20px;
    margin: -20px;
  }
</style>




// WEBPACK FOOTER //
// src/components/NavDrawer.vue